import { createAction, props } from '@ngrx/store';
import { IBusinessUserRolesRequest, IBusinessUserRolesResponse } from '../models/business-user-roles.model';

export const loadBusinessUserRoles = createAction(
  '[BusinessUserRole] Load BusinessUserRoles',
  props<{ request: IBusinessUserRolesRequest }>()
);

export const loadBusinessUserRolesSuccess = createAction(
  '[BusinessUserRole] Load BusinessUserRoles Success',
  props<{ response: IBusinessUserRolesResponse }>()
);

export const loadBusinessUserRolesFailure = createAction(
  '[BusinessUserRole] Load BusinessUserRoles Failure',
  props<{ error: Error | any }>()
);
